import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnalytics, getAnalytics } from '@angular/fire/analytics';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { FIREBASE_OPTIONS } from '@angular/fire/compat';
import { BUCKET } from '@angular/fire/compat/storage';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { providePerformance, getPerformance } from '@angular/fire/performance';
import { provideStorage, getStorage } from '@angular/fire/storage';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { OnlineStatusService } from 'ngx-online-status';
import { dbConfig } from './_configs/db.config';
import { environment } from '../environments/environment';
import { NgxIndexedDBModule } from 'ngx-indexed-db';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { authInterceptor } from './_interceptors/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimationsAsync(),
    importProvidersFrom(
      provideFirebaseApp(() => initializeApp(environment.firebase))
    ),
    importProvidersFrom(provideFirestore(() => getFirestore())),
    importProvidersFrom(provideAuth(() => getAuth())),
    importProvidersFrom(provideStorage(() => getStorage())),
    importProvidersFrom(providePerformance(() => getPerformance())),
    importProvidersFrom(provideFunctions(() => getFunctions(undefined, 'europe-west1'))),
    importProvidersFrom(provideAnalytics(() => getAnalytics())),
    importProvidersFrom(NgxIndexedDBModule.forRoot(dbConfig)),
    provideHttpClient(withInterceptors([authInterceptor])),
    OnlineStatusService,
    {
      provide: BUCKET,
      useValue: environment.production ? 'mevolve-marketing' : 'mevolve-marketing-dev'
    },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: FIREBASE_OPTIONS, useValue: environment.firebase },
  ]
};

